function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const formGroupStyles = process.env.NODE_ENV === "production" ? {
  name: "1x2a5pd",
  styles: "gap:16px"
} : {
  name: "1q2d974-formGroupStyles",
  styles: "gap:16px;label:formGroupStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2NpcmNsZWNpL3Byb2plY3QvYXNjZW5kL3NyYy9jb21wb25lbnRzL0Zvcm1Hcm91cC9Gb3JtR3JvdXAuc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVrQyIsImZpbGUiOiIvaG9tZS9jaXJjbGVjaS9wcm9qZWN0L2FzY2VuZC9zcmMvY29tcG9uZW50cy9Gb3JtR3JvdXAvRm9ybUdyb3VwLnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuZXhwb3J0IGNvbnN0IGZvcm1Hcm91cFN0eWxlcyA9IGNzc2BcbiAgZ2FwOiAxNnB4O1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export {
  formGroupStyles
};
//# sourceMappingURL=FormGroup.styles.js.map
